<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.providerSelection.title') }}
    </h2>
    <div class="form-grid">
      <div class="form_group">
        <div :class="[
          'radio-group',
          { 'is-invalid': formErrors.has('providerSelection.provider') }
        ]">
          <label class="radio-item">
            <input type="radio" value="meuhedet" v-model="form.provider"
              @change="clearError('providerSelection.provider')" />

              {{ t('employerForm.providerSelection.meuhedetHealthServices') }}
          </label>
          <label class="radio-item">
            <input type="radio" value="clalit" v-model="form.provider"
              @change="clearError('providerSelection.provider')" />

            {{ t('employerForm.providerSelection.clalitHealthServices') }}
          </label>
        </div>

        <p class="invalid-feedback" v-if="formErrors.has('providerSelection.provider')">
          {{ t(formErrors.first('providerSelection.provider')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },

  formErrors: {
    type: Object,
    required: false,
    default: reactive(new Error({}))
  }
});

const emit = defineEmits([
  'update:modelValue',
  'removeError'
]);

const form = reactive({
  ...props.modelValue
});

watch(
  form,
  (val) => emit('update:modelValue', val),
  { deep: true }
);

watch(
  () => props.modelValue,
  (newValue) => {
    Object.assign(form, newValue);
  },
  { deep: true, immediate: true }
);

const clearError = (name) => {
  emit('removeError', name);
};
</script>

<style scoped>
.radio-group {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0px;
  margin-top: 10px;
}
.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.radio-item input[type="radio"] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
}
.full-width {
  grid-column: span 2;
}
</style>